// WARNING: DO NOT EDIT. This file is automatically generated.

const awsConfig = {
    "region": "eu-central-1",
    "stage": "prod",
    "accountName": "wow-integration",
    "api_url": "https://4xky3g1pgk.execute-api.eu-central-1.amazonaws.com/prod/graphql",
    "notifications_api_url": "https://4xky3g1pgk.execute-api.eu-central-1.amazonaws.com/prod/notifications",
    "run_daily_test_url": "https://nhoa7taoq2.execute-api.eu-central-1.amazonaws.com/prod/run-daily-test",
    "sport_highlights_url": "https://rz5uyhxifncj5i5frp7gwejboy.appsync-api.eu-central-1.amazonaws.com/graphql",
    "appconfig_url": "https://4xky3g1pgk.execute-api.eu-central-1.amazonaws.com/prod/getConfig",
    "direct_appconfig_url": "https://h0kb4ij0n3.execute-api.eu-central-1.amazonaws.com/prod",
		"endpoint_url" : "https://4xky3g1pgk.execute-api.eu-central-1.amazonaws.com/prod",
    "mgmt_ui_appconfig_dropdown_profile": "mgmt-ui-dropdown-options",
    "mgmt_ui_appconfig_configs_profile": "mgmt-ui-configs",
    "daily-test-game-configs": "daily-testing-configs",
    "leagues": "leagues",
    "aws_project_region": "eu-central-1",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_coCj61otX",
    "aws_user_pools_web_client_id": "13nd1uni6esf9hslosithlijt4",
    "oauth": {
        "domain": "spex-mgmt-ui-hosting-wow-integrationprod.auth.eu-central-1.amazoncognito.com",
        "scope": [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://mgmt.wow-integration.aidisco.sky.com",
        "redirectSignOut": "https://mgmt.wow-integration.aidisco.sky.com",
        "responseType": "code"
    },
    "defaultChannelName": "ExternalSLE",
    "playfactoryLicenseAcquisitionEndpointUrl": "https://jj6xmu3q54.execute-api.eu-central-1.amazonaws.com/prod",
    "arcusLicenseAcquisitionEndpointUrl": "https://640wmn3pml.execute-api.eu-central-1.amazonaws.com/prod",
    "viperProxyUrl": ""
};

export default awsConfig;

